import React from 'react';

import { I18n } from 'aws-amplify';

import { Task } from '../../../utils/task';

import TextAreaField from '../../form/textarea-field';
import CheckboxField from '../../form/checkbox-field';

import { scrollToTop } from '../../../utils/ui';

class CostForm extends React.Component {
    constructor(props) {

        super(props);

        const { bPitch = {} } = props;

        this.state = {
            fields: {
                audience: {
                    onChange: this.onChangeForm.bind(this, 'audience'),
                    // onBlur: this.onSave.bind(this),
                    successIcon: false,
                    markAsRequired: true
                },
                placement: {
                    onChange: this.onChangeForm.bind(this, 'placement'),
                    // onBlur: this.onSave.bind(this),
                    successIcon: false,
                    markAsRequired: true
                },
            },
            errors: {},
            form: { ...bPitch },
            task: {},
            submit_task: {}
        }
    }

    componentDidMount() {
        scrollToTop();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        const task = this.props.task || {};
        const prev = prevProps && prevProps.task || {};

        //console.dir({ task: task, prev: prev });

        if (task != prev) {

            var nextState = Object.assign({}, prevState, { task: task });

            const { bPitch = {} } = this.props;

            Object.keys(this.state.fields).forEach((item) => {

                if (bPitch[item]) {
                    nextState.form[item] = bPitch[item];
                }

            });

            this.setState(nextState);
        }
    }

    onChangeForm(prop, e) {

        const value = e.target.value;

        this.setState((prevState) => {

            var nextState = Object.assign({}, prevState);

            nextState.form[prop] = value;
            nextState.errors[prop] = null;

            return nextState;

        }, () => this.onSaving() );
    }

    getData() {

        var data = {
            projectId: this.props.match.params.projectId,
            ...this.props.bPitch,
            ...this.state.form
        };

        return data;
    }

    onSaving(){

        clearTimeout(this.t);
        this.t = setTimeout(() => this.onSave(), 1000)
    }

    onSave() {

        var submit_task = new Task();

        submit_task.start();

        this.setState({ submit_task: submit_task });

        this.props.update_bpitch(this.getData())
            .then(({ task, errors }) => {

                this.setState({ submit_task: task, errors: errors });
            });
    }

    render() {

        
        const bPitch = this.props.bPitch || {};

        const { isAudienceInfoViaUpload } = bPitch;

        return (
            <div>

                <h1 className="title-bpool medium">{I18n.get("Público e abrangência")}</h1>

                <div className="bp-event-section" style={{ marginTop: '3rem', maxWidth: '40rem' }}>

                    <TextAreaField 
                        {...this.state.fields.audience} 
                        markAsRequired={!isAudienceInfoViaUpload}
                        markAsOptional={isAudienceInfoViaUpload}
                        label={I18n.get("Liste o (s) público(s) alvo(s) do projeto, em ordem de prioridade")}
                        value={this.state.form.audience} 
                        error={this.state.errors.audience} 
                        />

                    <br />

                    <TextAreaField 
                        {...this.state.fields.placement} 
                        markAsRequired={!isAudienceInfoViaUpload}
                        markAsOptional={isAudienceInfoViaUpload}
                        label={I18n.get("Especifique as praças de abrangência do projeto, em ordem de prioridade")}
                        value={this.state.form.placement} 
                        error={this.state.errors.placement} />

                    <br />

                </div>
            </div>
        );
    }
}

export default CostForm;
